import type { AsyncDataOptions } from '#app'
import type { GqlOps, GqlSdkFuncs } from '#gql'
import { obfuscateEmails } from '~/utils/emailObfuscation'

type CmsData<T extends keyof GqlSdkFuncs> = Awaited<ReturnType<GqlSdkFuncs[T]>>

// Drop-in replacement for useAsyncGql: obfuscates email addresses before the data is rendered
// and written to the Nuxt payload. Always load CMS data through this composable.
// GqlOps also lists fragment names, so T is narrowed to the actual SDK operations.
export const useCmsGql = <T extends GqlOps & keyof GqlSdkFuncs>({
  options,
  ...args
}: {
  operation: T
  variables?: Parameters<GqlSdkFuncs[T]>[0]
  options?: AsyncDataOptions<CmsData<T>>
}) =>
  useAsyncGql({
    ...args,
    options: {
      ...options,
      // Obfuscate first, so a caller's own transform never sees plain addresses
      transform: (data: CmsData<T>) =>
        options?.transform
          ? options.transform(obfuscateEmails(data))
          : obfuscateEmails(data),
    },
  })
